export { TechnicalData } from './TechnicalData';
export type { TechnicalDataProps } from './TechnicalData';
